import { render, staticRenderFns } from "./DeleteAccountPage.vue?vue&type=template&id=62664053&scoped=true"
import script from "./DeleteAccountPage.vue?vue&type=script&lang=js"
export * from "./DeleteAccountPage.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccountPage.vue?vue&type=style&index=0&id=62664053&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62664053",
  null
  
)

export default component.exports